export const color_stack = []



// WEBPACK FOOTER //
// ./src/global.js